import { toast } from "sonner";
import { ApiErrorResponse } from "../../types/api";
import * as Sentry from "@sentry/nextjs";

export class ApiError extends Error {
  constructor(
    public statusCode: number,
    public errors: ApiErrorResponse["error"],
    public type: string = "api_error"
  ) {
    super(`API Error: ${statusCode}`);
    this.name = "ApiError";
  }
}

export const handleApiError = (error: ApiError, showToast = true) => {
  if (showToast) {
    toast.error(error.message || error.statusCode);
  }

  console.error("API Error:", {
    statusCode: error.statusCode,
    type: error.type,
    errors: error.errors,
  });

  // Send to Sentry, especially for 500 errors
  if (process.env.NEXT_PUBLIC_ENABLE_SENTRY?.toLowerCase() === "true") {
    Sentry.captureException(error, {
      tags: {
        errorType: "api_error",
        statusCode: error.statusCode,
      },
      extra: {
        apiErrorDetails: error.errors,
        errorType: error.type,
      },
      // Capture 500 errors with higher severity
      level: error.statusCode >= 500 ? "error" : "warning",
    });
  }
};
